import React from "react";
import ReactDOM from "react-dom/client";

// Catch any initialization errors and display them
window.addEventListener("error", function(event) {
  const root = document.getElementById("root");
  if (root && !root.hasChildNodes()) {
    root.innerHTML = '<div style="padding:40px;font-family:monospace;color:#c00;background:#fff3f3;margin:20px;border-radius:8px;border:1px solid #c00"><h2>App failed to load</h2><pre style="white-space:pre-wrap;word-break:break-all">' + (event.error ? event.error.stack || event.message : event.message) + '</pre></div>';
  }
});

window.addEventListener("unhandledrejection", function(event) {
  console.error("Unhandled promise rejection:", event.reason);
});

try {
  // Dynamic imports wrapped in try/catch to surface errors
  const initApp = async () => {
    try {
      const [{ default: indexCss }, { default: App }] = await Promise.all([
        import("@/index.css"),
        import("@/App"),
      ]);

      const rootEl = document.getElementById("root");
      if (!rootEl) {
        document.body.innerHTML = '<div style="padding:40px;color:red">Root element not found!</div>';
        return;
      }

      const root = ReactDOM.createRoot(rootEl);
      root.render(
        <React.StrictMode>
          <App />
        </React.StrictMode>,
      );
    } catch (err) {
      console.error("App initialization error:", err);
      const root = document.getElementById("root");
      if (root) {
        root.innerHTML = '<div style="padding:40px;font-family:monospace;color:#c00;background:#fff3f3;margin:20px;border-radius:8px;border:1px solid #c00"><h2>App initialization failed</h2><pre style="white-space:pre-wrap;word-break:break-all">' + (err.stack || err.message || String(err)) + '</pre></div>';
      }
    }
  };

  initApp();
} catch (outerErr) {
  console.error("Fatal error:", outerErr);
  const root = document.getElementById("root");
  if (root) {
    root.innerHTML = '<div style="padding:40px;font-family:monospace;color:#c00"><h2>Fatal error</h2><pre>' + (outerErr.stack || outerErr.message) + '</pre></div>';
  }
}
